import { InferResponseType } from "hono/client";
import { client } from "../client";

export const TREES_PROGRESS_QUERY_KEY = ["trees", "progress"] as const;

export type TreesProgressResponse = InferResponseType<
  typeof client.trees.$get,
  200
>;

export type TreesProgressMilestone =
  TreesProgressResponse["milestones"][number];
